import { useField } from 'formik';
import React, { FC, ReactNode } from 'react';
import FieldControl from '../../atoms/field-control/field-control';
import FieldRadioGroup from '../field-radio-group/field-radio-group';

interface Props {
  className?: string;
  help?: string;
  label?: string;
  layout?: 'vertical' | 'horizontal';
  name: string;
  onChange?: (value: string | number) => void;
  options?: {
    value: string | number | null;
    label: ReactNode;
    disabled?: boolean;
  }[];
  required?: boolean;
  tooltipComponent?: ReactNode;
}

const FormRadioGroup: FC<Props> = ({
  className,
  help,
  label,
  layout,
  name,
  onChange,
  options,
  required,
  tooltipComponent,
}: Props) => {
  const [field, meta, helpers] = useField(name);

  return (
    <div className={className}>
      <FieldControl
        required={required}
        textLabel={label}
        help={help}
        error={meta.error}
        tooltipComponent={tooltipComponent}
      >
        <FieldRadioGroup
          layout={layout}
          options={options}
          value={field.value}
          onChange={(value) => {
            helpers.setValue(value);
            onChange(value);
          }}
          error={!!meta.error}
        />
      </FieldControl>
    </div>
  );
};

FormRadioGroup.defaultProps = {
  className: '',
  onChange: () => ({}),
  options: [],
  label: null,
  required: false,
  help: null,
  layout: 'vertical',
  tooltipComponent: null,
};

export default FormRadioGroup;
